// extracted by mini-css-extract-plugin
module.exports = {"title":"title--3Qn4Z","service":"service--2wC2a","contactBlock":"contactBlock--1-aQh","foreign":"foreign--3h0GN"};